// extracted by mini-css-extract-plugin
export var navbarSubLink = "M_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "M_vQ d_f0 d_dB";
export var subPageLink = "M_gf d_gf";
export var burger = "M_vT";
export var sublinkSize = "M_vV";
export var linkSize = "M_vW";
export var Link = "M_tw D_tw D_sN D_s6";